(function() {

    angular.module('BuscaAtivaEscolar').controller('CreditsCtrl', function($scope, $rootScope, AppDependencies) {

        $rootScope.section = 'credits';
        $scope.appDependencies = AppDependencies;

    });

})();